import React from 'react'
import { withStyles, Grid, Typography } from '@material-ui/core'
import twitterImg from '../images/svg/twitter.svg'
import fbImg from '../images/svg/fb.svg'
import { Link } from 'react-router-dom'

const SOCIAL_LINKS = [
  {
    url: 'https://twitter.com/dealvestors',
    src: twitterImg,
    altText: 'Twitter',
  },
  {
    url: 'https://www.facebook.com/dealvestors/',
    src: fbImg,
    altText: 'Facebook',
  },
]

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  footer: {
    height: '226px',
    backgroundColor: '#333645',
    boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.04)',
    color: '#ffd200',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '35px 20px 40px',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: '6',
  },
  smallFooter: {
    left: 'auto',
    width: '640px',
    minHeight: '160px',
    maxHeight: '160px',
    padding: '12px 25px',
    '& p': {
      marginTop: '10px',
    },
    '& p:last-child': {
      marginTop: '5px',
    },
    [theme.breakpoints.down('1024')]: {
      width: '338px',
      padding: '12px 15px',
      '&>div': {
        '&>div': {
          '&>p': {
            fontSize: '12px !important',
          },
        },
      },
      '& p': {
        fontSize: '15px',
      },
      '& p:last-child': {
        fontSize: '12px',
      },
    },
    [theme.breakpoints.down('768')]: {
      width: '100%',
      left: '0',
      '&>div': {
        '&>div': {
          '&>p': {
            fontSize: '15px !important',
          },
        },
      },
      '& p': {
        fontSize: '21px',
      },
      '& p:last-child': {
        fontSize: '15px',
      },
    },
    [theme.breakpoints.down('600')]: {
      '&>div': {
        '&>div': {
          '&>p': {
            fontSize: '14px !important',
          },
          '&>div': {
            padding: '5px 0',
          },
        },
      },
      '& p': {
        fontSize: '15px',
        margin: '0',
      },
      '& p:last-child': {
        fontSize: '12px',
      },
    },
  },
  footerLinks: {
    fontSize: '16px',
    fontWeight: '500',
    textDecoration: 'none',
    [theme.breakpoints.down('800')]: {
      fontSize: '14px',
    },
  },
  contentWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '0 auto',
    '& p': {
      marginTop: '0',
    },
  },
  footerColor: {
    color: '#ffd200',
  },
  socialIcons: {
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      textAlign: 'center',
      padding: '20px 0',
    },
  },
  copyrightText: {
    fontSize: '21px',
    fontWeight: '500',
    textAlign: 'center',
    marginTop: '40px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '15px',
      marginTop: 0,
    },
  },
  conditiontext: {
    fontSize: '15px',
    letterSpacig: '-0.5px',
    textAlign: 'center',
    margin: '10px 0 0',
    [theme.breakpoints.down('xs')]: {
      fontSize: '12px',
    },
  },
  appVersion: {
    fontSize: '10px',
    textAlign: 'center',
    color: '#888',
  },
  footerContent: {
    maxWidth: '592px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '424px',
    },
  },
  socialLink: {
    marginRight: '25px',
    '&:last-child': {
      marginRight: '0',
    },
  },
})

class Footer extends React.Component {
  render() {
    const { classes, map } = this.props

    return (
      <div className={classes.root}>
        <Grid container className={`${classes.footer} ${map ? classes.smallFooter : ''}`}>
          <Grid item xs={12} className={classes.footerContent}>
            <div className={classes.contentWrapper}>
              <Typography>
                <Link className={`${classes.footerColor} ${classes.footerLinks}`} to={`/aboutUs`}>
                  ABOUT
                </Link>
              </Typography>
              <Typography>
                <a className={`${classes.footerColor} ${classes.footerLinks}`} target="_blank" rel="noopener noreferrer" href="/terms">
                  TERMS
                </a>
              </Typography>
              <Typography>
                <Link className={`${classes.footerColor} ${classes.footerLinks}`} to={`/contactUs`}>
                  CONTACT
                </Link>
              </Typography>
              <div className={classes.socialIcons}>
                {SOCIAL_LINKS.map((obj, ix) => (
                  <a key={ix} className={classes.socialLink} href={obj.url} target="_blank" rel="noopener">
                    <img src={obj.src} alt={obj.altText} className={classes.socialImage} width={'25px'} height={'25px'} />
                  </a>
                ))}
              </div>
            </div>
            <Typography className={`${classes.footerColor} ${classes.copyrightText}`}>2019 HomeVestors® of America, Inc. All Rights Reserved</Typography>
            <Typography className={`${classes.footerColor} ${classes.conditiontext}`}>Each franchise office is independently owned and operated.</Typography>
            <Typography className={`${classes.appVersion}`}>
              Version {process.env.REACT_APP_VERSION}, built at {process.env.REACT_APP_BUILT_AT}.
            </Typography>
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer.js